import { render } from "./DrTheissPageModal.vue?vue&type=template&id=3f14ee9c"
import script from "./DrTheissPageModal.vue?vue&type=script&lang=js"
export * from "./DrTheissPageModal.vue?vue&type=script&lang=js"
script.render = render

export default script